export default () => ({
  translatedCalibrationHomepageMessage: ''
})
